module.exports = __webpack_public_path__ + "img/th.41a72c57.svg";